<template>
  <nav class="navbar navbar-expand-md navbar-light bg-white shadow-sm pt-2 ps-1 pe-3">
    <div class="container-fluid">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <button class="btn" @click="toggleSidebar()"><font-awesome-icon icon="bars" /></button>
        </li>
      </ul>

      <ul class="navbar-nav ms-auto mb-2 mb-md-0">
        <li class="nav-item dropdown my-auto ms-5">
          <!-- <img v-if="profilbild != null && profilbild.filecontentAsBase64 != ''" :src="'data:image/bmp;base64, ' + profilbild.filecontentAsBase64" alt="Profilbild" class="avatar me-2" /> -->
          <img src="@/assets/img/profilbild.png" alt="Profil Bild Rainer Zufall" class="avatar me-2" />

          <a class="nav-link dropdown-toggle d-inline pe-0" href="#" data-bs-toggle="dropdown" aria-expanded="false">{{
            user?.name != '' ? user?.name : user?.benutzername
          }}</a>
          <ul class="dropdown-menu m-0">
            <li>
              <button class="dropdown-item py-2" @click="logout">
                <font-awesome-icon icon="arrow-right-from-bracket" class="me-3" />
                Abmelden
              </button>
            </li>
            <li v-if="store.getters.isAdmin" class="border-top">
              <router-link :to="{ name: 'Einstellungen' }" class="dropdown-item py-2">
                <font-awesome-icon icon="gear" class="me-3" />
                Einstellungen
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed } from 'vue';
  import { useStore } from '@/store';
  import { useRouter } from 'vue-router';

  import { ActionTypes as AuthActionTypes } from '@/store/modules/Auth/actions';
  import { ActionTypes as CommonActionTypes } from '@/store/modules/Common/actions';
  //#endregion

  const store = useStore();
  const router = useRouter();

  const user = computed(() => store.getters.authUser);

  function logout() {
    store.dispatch(AuthActionTypes.Logout, undefined).then(() => {
      router.replace({ name: 'Logout' });
    });
  }

  function toggleSidebar() {
    store.dispatch(CommonActionTypes.ToggleSidebar, undefined);
  }
</script>

<style lang="scss" scoped>
  .navbar {
    z-index: 200;
  }

  img.avatar {
    object-fit: cover;
    border-radius: 50%;
    // border: 3px solid #770025;
    border: 3px solid #f1a82c;
    height: 45px;
    width: 45px;
  }
</style>
